import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AssignWalletOnParentRequest, AvailableWalletsResponse } from 'app/core/models/patient.model';
import { SelectOption } from 'app/core/models/select-option.model';
import { PatientService } from 'app/core/services/patient.service';
import { AlertService } from 'app/shared/alert/alert.service';
import { ModalComponent } from 'app/shared/modal/modal.component';

@Component({
  selector: 'app-card-already-active-modal',
  templateUrl: './card-already-active-modal.component.html',
  styleUrls: ['./card-already-active-modal.component.scss']
})
export class CardAlreadyActiveModalComponent {
  @ViewChild("modal") modal: ModalComponent;

  @Input() trialId: string;
  @Input() patientTrialId: string;
  @Input() paymentInfoForm: FormGroup;

  @Output('walletAssigned') walletAssigned = new EventEmitter();

  selectedWallet: AvailableWalletsResponse;
  processing = false;

  constructor(
    private patientService: PatientService,
    private alertService: AlertService
  ) { }

  onContinueMoveActiveCard() {
    this.processing = true;

    let request: AssignWalletOnParentRequest = {
      trialId: this.trialId,
      patientTrialId: this.patientTrialId,
      caxtonWalletId: this.selectedWallet.walletId,
      caxtonWalletName: this.selectedWallet.walletName,
    };

    this.patientService.assignWalletOnParent(request).subscribe({
      next: (result) => {
        this.processing = false;

        this.paymentInfoForm.get("caxtonWalletName").setValue(result.walletName);
        this.paymentInfoForm.get("caxtonWalletId").setValue(result.walletId);
        this.paymentInfoForm.get("caxtonWalletName").disable();
        this.paymentInfoForm.markAsDirty();

        this.modal.hide();

        this.walletAssigned.emit();

        this.alertService.showSuccessAlert(`You have successfully assigned ${result.walletName}`);
      },
      error: () => {
        this.alertService.showWarningAlert("There was a problem connecting to Caxton. Please retry and if the problem persists contact IT Support.");
        this.processing = false;
      },
    });
  }
}
